export interface CourseMapCoordinate {
  latitude: number
  longitude: number
}

export type Located<T> = T & { coordinate: CourseMapCoordinate }

/**
 * The cameras a map can pin: a finite, in-range coordinate. Location telemetry
 * starts before video publishing, so online state plays no part here; it only
 * changes a camera's treatment and whether it can open.
 */
export function locatedCameras<T extends { coordinate: CourseMapCoordinate | null }>(cameras: T[]): Located<T>[] {
  return cameras.filter((camera): camera is Located<T> => {
    const latitude = camera.coordinate?.latitude
    const longitude = camera.coordinate?.longitude
    return (
      typeof latitude === 'number' &&
      typeof longitude === 'number' &&
      Number.isFinite(latitude) &&
      Number.isFinite(longitude) &&
      Math.abs(latitude) <= 90 &&
      Math.abs(longitude) <= 180
    )
  })
}
